<template>
  <div class="col">
    <slot></slot>
    
    <div class="card card-fluid">
      <div class="card-body">
        <subdisciplines-table :discipline="discipline"></subdisciplines-table>
      </div>
    </div>
  </div>
</template>

<script>
  import 'jquery-validation'
  import { mapGetters } from 'vuex'
  import SubdisciplinesTable from '../components/catalogs/SubdisciplinesTable'
  
  export default {
    name: 'RegisterDiscipline',
    components: {
      SubdisciplinesTable,
    },
    data() {
      return {
        discipline: null,
      }
    },
    computed: {
      ...mapGetters(['accessToken']),
    },
    created() {
      this.discipline = window.discipline
    },
    mounted () {
      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            key: {
              required: true,
            },
            title: {
              required: true,
            },
            subdisciplines: {},
          },
          messages: {
            key: {
              required: 'Este campo es requerido.',
            },
            title: {
              required: 'Este campo es requerido.',
            },
            subdisciplines: {},
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
